import {createContext} from "react";

export const DailyMixContext = createContext([]);